import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Text, TextArea } from 'react-form';

import InputBase from 'forms/InputBase';
import InputBlock from 'forms/InputBlock';

class TextInput extends InputBase {

  renderInput() {
    const commonProps = {
      field:    this.props.name,
      onBlur:   this.props.onBlur,
      onChange: () => {
        this.clearServerError(this.props.name);
      },
      onKeyUp:  this.listenKeyboard,
      disabled: this.props.isDisabled,
    }

    if (this.props.labelAsPlaceholder === true) {
      commonProps.placeholder = this.props.label;
    }

    if (this.props.maxLength) {
      commonProps.maxLength = this.props.maxLength;
    }

    switch(this.props.type) {
      case 'textarea':
        return <TextArea className={this.inputClassName("input-textarea")} {...commonProps} />;
      default:
        return <Text className={this.inputClassName("input-text")} {...commonProps} type={this.props.type} />;
    }
  }

  render() {
    return (
      <InputBlock size={this.props.size} className={this.blockClassNames()}>
        {this.renderLabel()}
        {this.renderInput()}
        {this.props.children}
        {this.renderErrors()}
      </InputBlock>
    )
  }

}

TextInput.propTypes = {
  name:     PropTypes.string.isRequired,
  label:    PropTypes.string.isRequired,
  labelSecondary: PropTypes.string,
  type:     PropTypes.string,
  size:     PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.element,
  errors:   PropTypes.object,
  serverErrors: PropTypes.object,
  clearServerError: PropTypes.func,
  formApi:  PropTypes.object,
  onBlur:   PropTypes.func,
  showErrors:   PropTypes.bool,
  onEnter:   PropTypes.func,
  isDisabled:   PropTypes.bool,
};

TextInput.defaultProps = {
  type:   "text",
  isDisabled: false,
};

export default TextInput;
